import { DefinitionLevels, SettingValues } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';
import get from 'lodash/get';

const useWorkingDaysSettings = ({ teams = [] }) => {
  const { getSetting } = useSettingsService();

  const organizationWorkingDaySetting = getSetting({
    name: SettingValues.WORKING_DAYS,
    definitionLevel: DefinitionLevels.ORGANIZATION
  });
  // in case of single team and there is a setting we take it, if not we default to org setting, if no org setting we just take the default
  const workingDaysSetting =
    teams.length === 1 && get(teams, '[0].id')
      ? getSetting(
          {
            name: SettingValues.WORKING_DAYS,
            teamId: teams[0].id,
            definitionLevel: DefinitionLevels.TEAM
          },
          organizationWorkingDaySetting
        )
      : organizationWorkingDaySetting;
  return workingDaysSetting || organizationWorkingDaySetting;
};

export default useWorkingDaysSettings;
